import { render, staticRenderFns } from "./ApproveIndex.vue?vue&type=template&id=5f1f30a2&scoped=true"
import script from "./ApproveIndex.vue?vue&type=script&lang=js"
export * from "./ApproveIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1f30a2",
  null
  
)

export default component.exports